import { RootState } from '../root.reducer';

export const getCoolerTransactionState = (state: RootState) =>
  state.coolerTransaction;
export const getCoolerTransactionList = (state: RootState) => {
  // return the list data along with its loading flag so callers can destructure both
  return {
    coolerTransactions: state.coolerTransaction.coolerTransactions,
    loading: state.coolerTransaction.listLoading,
  };
};
export const getCoolerSingleTransaction = (state: RootState) => {
  // return the single transaction data along with its loading flag
  return {
    coolerTransaction: state.coolerTransaction.coolerTransaction,
    loading: state.coolerTransaction.singleLoading,
  };
};
// Backwards-compatible selector: returns the list loading flag
export const getCoolerTransactionLoading = (state: RootState) =>
  state.coolerTransaction.listLoading;
export const getCoolerTransactionListLoading = (state: RootState) =>
  state.coolerTransaction.listLoading;
export const getCoolerTransactionSingleLoading = (state: RootState) =>
  state.coolerTransaction.singleLoading;
export const getCoolerTransactionError = (state: RootState) =>
  state.coolerTransaction.error;
